import React, {useState} from 'react';
import {Icon, Modal, Grid, Button} from 'semantic-ui-react';

const WtsParamStatusTechDetailsModal = () => {
  const [showModal, setShowModal] = useState(false);

  const showModalClick = (e, value) => {
    e.preventDefault();
    setShowModal(value);
  };

  return (
    <Modal
      open={showModal}
      trigger={
        <Icon
          name='info circle'
          size="big"
          color="blue"
          link
          onClick={(e) => showModalClick(e, true)}
        />
      }
    >
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            Detalles técnicos: Parámetros WTS
          </h2>
          <Icon
            className='download'
            name='close'
            style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showModalClick(e, false)}
          />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid celled>
          <Grid.Row>
            <Grid.Column width={3}><strong>Frontend</strong></Grid.Column>
            <Grid.Column width={13}>
              /src/wts/catalogs/parameters
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}><strong>Backend</strong></Grid.Column>
            <Grid.Column width={13}>
              <div>
                <strong>getWtsParameters</strong>:
                {' '}<span style={{'color': '#2185d0'}}>GET</span>
                {' '}/api/wts/params?area=[id]
              </div>
              <div>
                <strong>createWtsParameter</strong>:
                {' '}<span style={{'color': '#21ba45'}}>POST</span>
                {' '}/api/wts/params
              </div>
              <div>
                <strong>updateWtsParameter</strong>:
                {' '}<span style={{'color': '#f2711c'}}>PUT</span>
                {' '}/api/wts/params/{'{param_id}'}
              </div>
              <div>
                <strong>deleteWtsParameter</strong>:
                {' '}<span style={{'color': '#db2828'}}>DELETE</span>
                {' '}/api/wts/params/{'{param_id}'}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}><strong>BDD</strong></Grid.Column>
            <Grid.Column width={13}>
              <div>Esquema: <strong>WTS</strong></div>
              <div>Tabla: <strong>TDE_WTS_PARAMETROS</strong></div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}><strong>Manual de usuario</strong></Grid.Column>
            <Grid.Column width={13}>
              <div style={{'display': 'flex', 'alignItems': 'center'}}>
                <a
                  href="https://scribehow.com/viewer/Modulo_WTS__ljtxcA-_RAy789Eiltmerw"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{'marginRight': '20px'}}
                >
                  Catálogos (Scribe - Externo)
                </a>
                <Button
                  as="a"
                  href="/media/docs/manualWTS.pdf"
                  download="manualWTS.pdf"
                  size="small"
                  color="blue"
                >
                  <Icon name="file pdf outline" /> Descargar PDF
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

export default WtsParamStatusTechDetailsModal;
